import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type TypographyVariant = "h1" | "h2" | "h3" | "body" | "muted";

type TypographyProps = {
  readonly as?: "p" | "h1" | "h2" | "h3" | "span";
  readonly variant?: TypographyVariant;
  readonly className?: string;
  readonly children: ReactNode;
};

const variantClasses: Record<TypographyVariant, string> = {
  h1: "text-2xl font-bold tracking-tight text-heading",
  h2: "text-xl font-semibold tracking-tight text-heading",
  h3: "text-lg font-medium text-heading",
  body: "text-sm font-medium text-body",
  muted: "text-sm text-gray-500"
};

export const Typography = ({
  as = "p",
  variant = "body",
  className,
  children
}: TypographyProps) => {
  const Component = as;
  const classes = twMerge(variantClasses[variant], className);

  return <Component className={classes}>{children}</Component>;
};

